export default __webpack_public_path__ + "static/media/b-4.3d424030.png";